import React from 'react';

import Card from 'ui/Card';

import { ReactComponent as WelcomeIcon } from 'assets/images/icons/welcome.svg';
import { ReactComponent as BellIcon } from 'assets/images/icons/bell.svg';

export const Welcome: React.FC = () => {
  return (
    <div className="welcome-view">
      <div className="welcome-view__content">
        <Card className="welcome-view__card-main">
          <div className="welcome-view__illustration">
            <WelcomeIcon />
          </div>

          <h1 className="welcome-view__title">Welcome to Prime Oasis AI!</h1>
          <p className="welcome-view__subtitle">
            Your account has been successfully created.
          </p>
        </Card>

        <Card className="welcome-view__card-info">
          <span className="welcome-view__info-icon">
            <BellIcon />
          </span>

          <div className="welcome-view__info-text">
            <p className="welcome-view__info-title">
              You don&apos;t have any objects or zones assigned yet
            </p>

            <p className="welcome-view__info-description">
              Please contact your administrator to get access to monitoring areas and
              sensors
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Welcome;
